import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Alert } from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import Header from '../components/Header'
import AddHeader from '../components/add/AddHeader'
import AddInstanceForm from '../components/add/AddInstanceForm'
import servicio from '../services/apiInstanceService'
import '../styles/FormView.css'
import apiDistributorService from '../services/apiDistributorService'

function AddView() {
  const INSTANCE_NAME_PATTERN = /^[a-z0-9-]+$/
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    name: '',
    fiscalName: '',
    status: 'ACTIVE',
    distributorId: '',
  })

  const [errors, setErrors] = useState({})
  const [submitted, setSubmitted] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [distributors, setDistributors] = useState([])
  const [isLoadingDistributors, setIsLoadingDistributors] = useState(false)
  const [distributorsError, setDistributorsError] = useState('')

  const validateField = (fieldName, fieldValue) => {
    const value = typeof fieldValue === 'string' ? fieldValue : ''

    if (fieldName === 'name') {
      if (!value.trim()) {
        return 'El nombre es requerido'
      }
      if (!INSTANCE_NAME_PATTERN.test(value)) {
        return 'El nombre solo puede contener minusculas, numeros y guion (-), sin espacios ni acentos.'
      }
    }

    if (fieldName === 'fiscalName' && !value.trim()) {
      return 'El nombre fiscal es requerido'
    }

    if (fieldName === 'distributorId' && !value.trim()) {
      return 'El distribuidor es requerido'
    }

    return ''
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))

    const nextFieldError = validateField(name, value)
    if (submitted || errors[name] || name === 'name') {
      setErrors((prev) => ({
        ...prev,
        [name]: nextFieldError,
      }))
    }
  }

  const validateForm = () => {
    const newErrors = {}

    const nameError = validateField('name', formData.name)
    const fiscalNameError = validateField('fiscalName', formData.fiscalName)
    const distributorError = validateField('distributorId', formData.distributorId)

    if (nameError) newErrors.name = nameError
    if (fiscalNameError) newErrors.fiscalName = fiscalNameError
    if (distributorError) newErrors.distributorId = distributorError

    return newErrors
  }

  useEffect(() => {
    let isMounted = true
    const loadDistirbutor = async () => {

      try {

        const distributorData = await apiDistributorService.listDistributors(0, 1000)  
        const distributorContent = Array.isArray(distributorData?.content) ? distributorData.content : []
        if (isMounted) {
          setDistributors(distributorContent)
        }
      } catch (error) {
        if (isMounted) {
          alert(error)
          setDistributorsError('No se pudieron cargar los distribuidores.')
        }
      } finally {
        if (isMounted) {
          setIsLoadingDistributors(false)
        }
      }
    }

    loadDistirbutor()
    return () => {
      isMounted = false
    }
  }, [])

  const handleSubmit = async (event) => {
    event.preventDefault()
    setSubmitted(true)
    setErrorMessage('')

    const newErrors = validateForm()
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    setIsSaving(true)
    try {
      await servicio.crearInstancia({
        name: formData.name,
        fiscalName: formData.fiscalName,
        status: 'ACTIVE',
        distributorId: formData.distributorId ? Number(formData.distributorId) : null,
      })
      navigate('/index')
    } catch (error) {
      const message = error?.body?.message || 'No se pudo crear la instancia.'
      setErrorMessage(message)
    } finally {
      setIsSaving(false)
    }
  }

  const handleCancel = () => {
    navigate(-1)
  }

  return (
    <>
      <Header />
      <Container fluid className="form-container">
        <Container>
          <AddHeader title="Crear Nueva Instancia" />

          {errorMessage && (
            <Row className="mb-3">
              <Col md="8">
                <Alert color="danger">{errorMessage}</Alert>
              </Col>
            </Row>
          )}


          <Row>
            <Col md="8">
              <AddInstanceForm
                formData={formData}
                errors={errors}
                submitted={submitted}
                isSaving={isSaving}
                distributors={distributors}
                isLoadingDistributors={isLoadingDistributors}
                onChange={handleInputChange}
                onSubmit={handleSubmit}
                onCancel={handleCancel}
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  )
}

export default AddView
